import { Instance } from 'mobx-state-tree'
import { GameEventModelBase } from './GameEventModel.base'

/* The TypeScript type of an instance of GameEventModel */
export interface GameEventModelType extends Instance<typeof GameEventModel.Type> {}

/* A graphql query fragment builders for GameEventModel */
export { selectFromGameEvent, gameEventModelPrimitives, GameEventModelSelector } from './GameEventModel.base'

/**
 * GameEventModel
 */
export const GameEventModel = GameEventModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
